<template>
  <div class="sigongge">
    <div v-for="(v, i) in hdArr" :key="i" class="videobox">
      <vidobox @delobj='delVedio' :isShowAdd="isShowAdd" :id="'vides' + i" :url="qing == 1 ? v.liveUrl : v.liveUrlHd" :list="v"
        :width="width" :height="height" :kbottom="'0px'" :kheight="'30px'" :token="token" :fontsize="'20px'" />
    </div>

    <div v-show="hdArr.length < v" v-for="(v, i) in 4" :key="i">
      <img src="../../assets/image/暂无视频@2x.png" alt="">
      <p>点击
        <span>视频监控列表</span>
        加载视频流
      </p>
    </div>
  </div>
</template>

<script>
var flage = 1
export default {
  props: {
    hdArr: {
      default: []
    },
    qing: {
      default: 1
    },
    token: {
      default: ''
    },
    isShowAdd: {
      default: true,
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  mounted() {
    this.getBox()
  },

  methods: {
    getBox() {
      let box = document.getElementsByClassName('videobox')
      console.log(box, 76);
      this.width = box[0].clientWidth;
      this.height = box[0].clientHeight;
    },
    delVedio(obj) {
      this.$emit('delobj', obj);
    }

  },



}


</script>

<style lang="scss" scoped>
.sigongge {
  width: 100%;
  height: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  position: relative;

  >div {
    width: 49%;
    height: 48%;
    background: #16385E;
    border-radius: .5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 15%;
      margin-bottom: 3%;
    }

    p {
      font-size: 1rem;
      color: #5D7C9E;

      span {
        color: #ffffffa0;
      }
    }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0, 0, 0, 0.5);
    z-index: 9999999999;

    .iconbox {
      width: 100%;
      height: 100%;
      display: flex;
      font-size: 100px;
      justify-content: center;
      align-items: center;
    }
  }

  .kong {
    position: absolute;
    left: 0;
    // bottom: 40px;
    width: 100%;
    // height: 40px;
    background: rgb(0, 0, 0, 0.5);

    .zhi {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;

      .left {
        i {
          margin-right: 10px;
        }
      }

      i {
        vertical-align: middle;
        color: #fff;

      }
    }

  }
}
</style>